<template>
  <!-- 長期不在登録画面 -->
  <v-dialog v-model="dialog" persistent max-width="650px">
    <v-container>
      <v-card>
        <v-card-title class="InsertTitle">
          <v-toolbar class="headline" color="primary" dark>{{this.title}}</v-toolbar>
        </v-card-title>
        <v-card-text class="cardTextStyle">
          <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" v-if="!ryoseiFlg">
                <RyouAutocomplete  v-model="model.user_id" :value="model.user_id"
                                  :items="selectUserListItems" :itemText="'user_name'"
                                  :itemValue="'user_id'"
                                  :disabled="LongAbsenceUpdateFlg">
                </RyouAutocomplete>
              </v-col>
              <v-col cols="12" v-if="ryoseiFlg">
                <RyouInput v-model="model.user_id" :value="model.user_id" :label="'ユーザID'" :maxlength="10" :disabled="true">
                </RyouInput>
              </v-col>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="5" md="5" lg="5">
                <RyouDateFormat v-model="startDate" :value="startDate" :type="'date'" :format="'$1/$2/$3'"
                                :label="'不在開始日'" :rules="dateRules" style="width: 40%;">
                </RyouDateFormat>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="5" md="5" lg="5">
                <RyouDateFormat v-model="endDate" :value="endDate" :type="'date'" :format="'$1/$2/$3'"
                                :label="'不在終了日'" :min="selectMin" :rules="dateRules" style="width: 40%;">
                </RyouDateFormat>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-row>
              <v-col :cols="12">
                <ryou-textarea v-model="model.remark" :value="model.remark" :label="'特記事項'" :maxlength="128"
                               :outlined="true">
                </ryou-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'"></ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'登録'" :handlerClick="handleOkConfirm"></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
    <ryou-confirm ref="confirm"></ryou-confirm>
  </v-dialog>
</template>

<script>
  import RyouTextarea from "@/components/formInput/RyouTextarea.vue";
  import RyouInput from "@/components/formInput/RyouInput.vue";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
  import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
  import RyouAutocomplete from "@/components/formInput/RyouAutocomplete.vue";

  export default {
    name: "BuildingLongAbsenceDialog",
    components: {
      RyouTextarea,
      RyouBlackBtn,
      RyouDateFormat,
      RyouConfirm,
      RyouAutocomplete,
      RyouInput,
    },
    mounted() {
      this.dateRules.push(this.GlobalRules.required);
    },
    props: {
      url: {
        type: Object,
        required: true,
        default: () => { },
      },
      building: {
        type: String,
        required: true,
        default: () => { },
      }
    },
    data: () => ({
      ryoseiFlg:true,
      title: "",
      selectUserListItems: [],
      selectUser:"",
      dialog: false,
      LongAbsenceUpdateFlg: true,
      valid: true,
      dateRules: [],
      model: {
        key_no:"",
        user_id:"",
        start_date: "",//不在開始日
        end_date: "",//不在終了日
        remark:""
      },
      selectMin: "",
      startDate: "",//不在開始日
      endDate: "",//不在終了日
    }),
    watch: {
      startDate(value) {

        if (value != null && value != "") {
          this.selectMin = value;
        }
        let fromDate = new Date(
          Date.parse(this.startDate)
        );
        let toDate = new Date(
          Date.parse(this.endDate)
        );
        if (fromDate.getTime() > toDate.getTime()) {
          this.endDate = "";
        }
      },
    },
    methods: {
      add() {
        this.LongAbsenceUpdateFlg = false
        this.open(false);
        this.title = "長期不在登録"
      },

      edit(record) {
        this.LongAbsenceUpdateFlg = true
        this.open(true);
        this.title = "長期不在更新";

        setTimeout(() => {
          this.model = Object.assign({}, record);
          this.selectUser = this.model.user_id;
          this.startDate = this.model.start_date.replace(/\//g, "-");
          this.endDate = this.model.end_date.replace(/\//g, "-");
        }, 10);

      },
      handleOkConfirm() {
        var valid = this.$refs.p1DialogForm.validate();
        if (valid) {
          this.$refs.confirm.open("登録", "登録します。宜しいですか？", { color: "info" }).then((confirm) => {
            if (confirm) {
              this.handleOk();
            }
          });
        }
      },
      handleOk() {
        var that = this;
        let params;
        if (!this.LongAbsenceUpdateFlg) {
          params = {
            key_no: null,
            user_id: this.model.user_id,
            start_date : this.startDate,
            end_date : this.endDate,
            reg_user_id: this.$store.getters.getUserId,
            remark:this.model.remark
          };
        }
        else {
          params = {
            key_no: this.model.key_no,
            user_id: this.model.user_id,
            start_date: this.startDate,
            end_date: this.endDate,
            reg_user_id: this.$store.getters.getUserId,
            remark: this.model.remark
          }

        }
        this.putRequest(this.url.update, params, this.$store.getters.getUserToken).then((resp) => {
          if (resp.success) {
            that.$emit("ok");
            that.close();
          }
        });
     },
      handleCancel() {
        this.close();
      },
      close() {
        this.dialog = false;
        if (this.$refs.p1DialogForm) {
          this.$refs.p1DialogForm.reset();
          this.$refs.p1DialogForm.resetValidation();
        }
      },
      open(updFlg) {
        this.clearData();
        this.dialog = true;

        //ユーザクラスが寮生以外の場合は選択リストを取得
        if (this.$store.getters.getUserClass != 3) {
          this.fetchSelectUserList(updFlg)
          this.ryoseiFlg = false;
        }else {
          this.model.user_id = this.$store.getters.getUserId
          this.ryoseiFlg = true;
        }

      },
      clearData() {
        setTimeout(() => {
          this.selectMin = "";
          this.startDate = "";//不在開始日
          this.endDate = "";//不在終了日
        }, 10);
      },
      fetchSelectUserList(updFlg) {
        var that = this;
        this.getRequest(this.url.getUserList + "/" + updFlg, null, this.$store.getters.getUserToken)
          .then((data) => {
            if (data.success) {
              //リスト用にデータ成型
              var mapDatas = data.result.map(item => {
                item.user_name = item.building_name + "　" + item.room_id + "　" + item.user_id + "　" +item.user_name
                return item
              });
              that.selectUserListItems = mapDatas;
          }
          });

      }
    },
  };
</script>

<style scoped>
  .InsertTitle {
    padding: 0px 0px 25px !important;
  }

  .titleStyle {
    line-height: 72px;
    width: 75px;
    margin-left: 2%;
  }

  .cardTextStyle {
    color: #000000DE !important;
    font-size: 16px !important;
  }
</style>